// extracted by mini-css-extract-plugin
export default {"dateTextContainer":"styles_dateTextContainer__ci0lV","red":"styles_red__WGNUW","dateText":"styles_dateText__TheeZ"};